import axios, { AxiosRequestConfig } from "axios";
import { DataToSend } from "../types/checklistData";

export const getChecklist = async (
  token: string,
  checklistId: string,
  vehicleId: string
) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/manager/checklist/${checklistId}/${vehicleId}`;
    const response = await axios.get(url, config);

    return response.data;
  } catch (error) {
    console.error("Erro ao buscar detalhes do checklist:", error);
    throw error;
  }
};

export const sendChecklistResponse = async (
  token: string,
  dataToSend: DataToSend
) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/entrega/checklist/respondido`;
    const response = await axios.post(url, dataToSend, config);

    return response.data;
  } catch (error) {
    console.error("Erro ao enviar respostas do checklist:", error);
    throw error;
  }
};

export const sendChecklistImageResponse = async (
  idChecklist: number,
  base64ImageData: string,
  token: string
) => {
  const url = `${process.env.REACT_APP_API_DOMAIN}/entrega/checklist/respondido/foto`;
  const data = {
    id_checklist_respondido: idChecklist,
    data: base64ImageData,
  };

  try {
    const response = await axios.post(url, data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
      },
    });

    if (response.status !== 200) {
      throw new Error("Erro ao enviar a foto para o banco de dados.");
    }
  } catch (error) {
    console.error("Erro ao enviar a foto para o banco de dados:", error);
    throw error;
  }
};

export const sendChecklistPerguntaImageResponse = async (
  idChecklist: number,
  base64ImageData: string,
  token: string,
  idPergunta: number
) => {
  const url = `${process.env.REACT_APP_API_DOMAIN}/entrega/checklist/respondido/pergunta/foto`;
  const data = {
    id_checklist_pergunta: idPergunta,
    id_checklist_respondido: idChecklist,
    data: base64ImageData,
  };

  try {
    const response = await axios.post(url, data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
      },
    });

    if (response.status !== 200) {
      throw new Error("Erro ao enviar a foto para o banco de dados.");
    }
  } catch (error) {
    console.error("Erro ao enviar a foto para o banco de dados:", error);
    throw error;
  }
};

export const sendChecklistSignedResponse = async (
  idChecklist: number,
  base64ImageData: string,
  token: string
) => {
  const url = `${process.env.REACT_APP_API_DOMAIN}/entrega/checklist/respondido/assinatura`;
  const data = {
    id_checklist_respondido: idChecklist,
    data: base64ImageData,
  };

  try {
    const response = await axios.post(url, data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
      },
    });

    if (response.status !== 201) {
      throw new Error("Erro ao enviar a assinatura para o banco de dados.");
    }
  } catch (error) {
    console.error("Erro ao enviar a assinatura para o banco de dados:", error);
    throw error;
  }
};

export const generatePDF = async (
  token: string,
  id_checklist_respondido: number
) => {
  try {
    const url = `${process.env.REACT_APP_API_DOMAIN}/entrega/pdfCreate/${id_checklist_respondido}`;
    const config: AxiosRequestConfig = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
      },
    };

    const response = await axios.post(url, null, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao gerar PDF:", error);
    throw error;
  }
};

export const generatePDFGroup = async (token: string, id_veiculo: number) => {
  try {
    const url = `${process.env.REACT_APP_API_DOMAIN}/entrega/pdfGroupCreate/${id_veiculo}`;
    const config: AxiosRequestConfig = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
      },
    };

    const response = await axios.post(url, null, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao gerar PDF:", error);
    throw error;
  }
};

export const getChecklistAnswered = async (
  token: string,
  id_checklist_respondido: string
) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/entrega/checklist/respondido/${id_checklist_respondido}`;
    const response = await axios.get(url, config);

    return response.data;
  } catch (error) {
    console.error("Erro ao visualizar detalhes do checklist:", error);
    throw error;
  }
};

export const validateChecklist = async (
  token: string,
  validationData: {
    id_checklist_respondido: number;
    validado: boolean;
    condicao_checklist_respondido: string;
    valor_checklist_respondido: number | null;
  }
) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };
    const url = `${process.env.REACT_APP_API_DOMAIN}/entrega/checklist/respondido/valida/${validationData.id_checklist_respondido}`;
    const response = await axios.post(url, validationData, config);

    return response.data;
  } catch (error) {
    console.error("Erro ao validar checklist:", error);
    throw error;
  }
};

